<template>
  
  <div class="pagination_container" v-show="!hidden">
    <el-pagination
      v-bind="pageAttrs"
      v-model:current-page="currentPage"
        v-model:page-size="pageSize"
      :background="background"
      :layout="layout"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script setup>
import { computed, ref, reactive, onBeforeMount, useAttrs } from "vue";
import { scrollTo } from "./scroll-to";
import { useVModel } from "@vueuse/core";
const attrs = useAttrs();
const pageAttrs = computed(() => {
  const { autoScroll, pagerCount, hidden, ...rest } = attrs;
  return rest;
});

const props = defineProps({
  total: {
    type: Number,
    default: 0,
  },
  pageSizes: {
    type: Array,
    default() {
      return [10, 20, 30, 50];
    },
  },
  // 移动端页码按钮的数量端默认值5
  pagerCount: {
    type: Number,
    default: document.body.clientWidth < 992 ? 5 : 7,
  },
  layout: {
    type: String,
    default: "total, sizes, prev, pager, next, jumper",
  },
  background: {
    type: Boolean,
    default: true,
  },
  autoScroll: {
    type: Boolean,
    default: true,
  },
  hidden: {
    type: Boolean,
    default: false,
  },
  currentPage: {
    type: Number,
  },
  pageSize: {
    type: Number,
  },
});

const emit = defineEmits(["pagination", "update:currentPage", "update:pageSize"]);
const currentPage = useVModel(props, "currentPage", emit);
const pageSize = useVModel(props, "pageSize", emit);
function handleSizeChange(val) {
  if (currentPage.value * val > props.total) {
    currentPage.value = 1
  }
  emit("pagination", { currentPage: currentPage.value, pageSize: val });
  if (props.autoScroll) {
    scrollTo(0, 800);
  }
}
function handleCurrentChange(val) {
  emit("pagination", { currentPage: val, pageSize:pageSize.value });
  if (props.autoScroll) {
    scrollTo(0, 800);
  }
}
</script>

<style scoped>
.pagination_container {
  background: var(--color-fg);
  padding-top: 12px;

  display: flex;
  justify-content: flex-end;
}
</style>
